import { LegalPage } from "./Legal";

export function PrivacidadPage() {
  return <LegalPage locale="es" doc="privacy" />;
}

export function TerminosPage() {
  return <LegalPage locale="es" doc="terms" />;
}

export function PrivacyPage() {
  return <LegalPage locale="en" doc="privacy" />;
}

export function TermsPage() {
  return <LegalPage locale="en" doc="terms" />;
}
